import { useTranslation } from "react-i18next";

/** Explains that the plan is managed by us; the button runs `onMessageUs` so the customer can ask to change or cancel. */
export function ManagedPlanNote({ onMessageUs }: { onMessageUs: () => void }) {
  const { t } = useTranslation();

  return (
    <div className="max-w-[220px] text-right text-xs text-muted-foreground">
      <p className="text-balance">{t("PRICING.HIGH_VALUE_PLAN_NOTE")}</p>
      <button
        type="button"
        onClick={onMessageUs}
        className="mt-1 font-semibold text-foreground underline underline-offset-2 hover:text-primary"
      >
        {t("PRICING.ACTION.MESSAGE_US", "Message us")}
      </button>
    </div>
  );
}
